<template>
  <div class="container _container">
    <MainTop :titlename="$i18n.locale=='zh_HK'? list.title:list.titleEn" :imgsrc="getimgsrc(list.titleImg)" :type="7"/>
    <div class="contentbody">
      <div class="bodymiddle">
        <div class="table">
          <form @keyup="keyup">
            <input type="text" v-model="form.name" :placeholder="$t('header.Name')" style="background-color: transparent;"/><br/>
            <input type="text" v-model="form.email" :placeholder="$t('header.Email1')" style="background-color: transparent;"/><br/>
            <input type="text" v-model="form.phone" :placeholder="$t('header.Phone')" style="background-color: transparent;"/>
            <!--            <button class="button" @click="addContact">Send</button>-->
            <div class="button" id="btn_send" @click="addContact" type="submit">{{$t('header.send')}}</div>
            <BombTips v-bind.sync="showBombTips" :tipsContent="tipsContent"></BombTips>
          </form>
        </div>
        <div class="conbox">
          <textarea :placeholder="$t('header.Remark')" @keyup="keyup" v-model="form.remark" style="background-color: transparent;"></textarea>
        </div>
      </div>
    </div>
    <Mapposition/>
  </div>
</template>
<script>
  import MainTop from '@/views/comcomponents/MainTop'
  import BombTips from "./BombTips";
  import Mapposition from '@/views/comcomponents/Mapposition';
  import {getListContacts, addContact} from '@/api/home';

  export default {
    name: 'Contacts',
    components: {
      MainTop,
      BombTips,
      Mapposition
    },
    data() {
      return {
        list: '',
        form: {
          name: '',
          email: '',
          phone: '',
          remark: '',
        },
        showBombTips: {
          visible: false
        },
        tipsContent: ""
      }
    },
    created() {
      this.getListContacts();

    },
    methods: {
      getListContacts() {
        getListContacts().then(response => {
          const data = response.data;
          this.list = data.data[0];
        })
      },
      getimgsrc(imgvalue) {
        if (imgvalue == null || imgvalue == '') {
          return '-'
        }
        var imgs = imgvalue.replace(/,/g, "")
        return process.env.BASE_IMG + imgs
      },
      async addContact() {
        document.getElementById("btn_send").style.background='#FFFFFF';
        document.getElementById("btn_send").style.color='#808080';
        let formPam={
          name : this.form.name,
          email : this.form.email,
          phone : this.form.phone,
          remark : this.form.remark,
        }
        this.form.remark = '';
        await addContact(formPam).then((response) => {
          const data = response.data
          if ( data.code= "success") {
            this.showBombTips = {
              visible: true
            };
            this.tipsContent = data.msg;
          }
        })
        this.form.remark = '';
      },
      keyup(){
        if(this.form.name==''||this.form.email==''||this.form.phone==''||this.form.remark==''){
          document.getElementById("btn_send").style.background='#FFFFFF';
          document.getElementById("btn_send").style.color='#808080';
          return true;
        }
        document.getElementById("btn_send").style.background='#13CE66';
        document.getElementById("btn_send").style.color='#FFFFFF';
        return true;
      }
    },
  }
</script>

<style lang="less" scoped>
  ::-webkit-input-placeholder { color:#eeeeee; }

  // 大于800px
  @media only screen and (min-width: 800px) {
    .container {
      background-color: #A5A5A5;
      overflow: hidden;
      position: relative;

      .contentbody {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;


        .bodymiddle {
          bottom: 20%;
          width: 80%;
          display: flex;
          left: 50%;
          transform: translateX(-50%);
          /*height: 80vh;*/
          position: absolute;
          .table {
            width: 45%;
            margin-top: -4%;

            input {
              width: 100%;
              border: 1px solid #eeeeee;
              margin: 25px 0;
              border-radius: 5px;
              color:#fff ;
              font-weight: bold;
              font-size: 1em;
              height: 5vh;
              padding-left: 10px;
            }

          }

          .conbox {
            margin-left: 7%;
            width: 60%;
            height: 35vw;

            textarea {
              margin-top: -4%;
              width: 100%;
              border: 1px solid #eeeeee;
              padding-top: 5px;
              /*margin: 10px 0;*/
              border-radius: 5px;
              font-family: "微软雅黑";
              color:#fff ;
              font-weight: bold;
              font-size: 1em;
              height: 20vw;
              padding-left: 10px;
            }
          }

          .button {
            margin-bottom: 2%;
            position: absolute;
            bottom: 25%;
            left: 44%;
            background-color: white;
            border: none;
            color: #808080;
            padding: 10px 45px;
            text-align: center;
            text-decoration: none;
            display: inline-block;
            font-size: 1.3em;
            font-weight: bold;
            border-radius: 25px;
          }

        }
      }


    }
  }

  // 小于800px
  @media only screen and (max-width: 800px) {
    .container {
      background-color: #A5A5A5;
      overflow: hidden;
      font-size: 1.5vw;
      overflow: hidden;
      .contentbody {
        /*position: relative;*/
        width: 100%;
        height: 100%;
        display: flex;
        /*flex-direction: column-reverse;*/
        justify-content: center;
        align-items: center;
        position: relative;
        /*margin-top: -5%;*/
        .bodymiddle {
          /*margin-top: 38%;*/
          /*margin-bottom: 15%;*/
          bottom: 20%;
          width: 80%;

          /*height: 100%;*/
          display: flex;
          position: absolute;
          /*height: 80vh;*/

          .table {
            width: 45%;
            margin-top: -6%;
            /*position: absolute;*/

            input {
              width: 100%;
              border: 1px solid #eeeeee;
              margin: 10px 0;
              border-radius: 5px;
              color:#fff ;
              font-weight: bold;
              font-size: 1em;
              height: 4vw;
              padding-left: 10px;
            }
          }

          .conbox {
            margin-left: 7%;
            width: 60%;
            height: 35vw;
            /*background-color: white;*/

            textarea {
              margin-top: -6%;
              width: 100%;
              border: 1px solid #eeeeee;
              padding-top: 5px;
              /*margin: 10px 0;*/
              border-radius: 5px;
              font-family: "微软雅黑";
              color:#fff ;
              font-weight: bold;
              font-size: 1em;
              height: 30vw;
              padding-left: 10px;
            }
          }

          .button {
            margin-bottom: 2%;
            bottom: 1%;
            left: 44%;
            position: absolute;
            background-color: white;
            border: none;
            color: #808080;
            padding: 1% 3.2%;
            text-align: center;
            text-decoration: none;
            display: inline-block;
            font-size: 1em;
            font-weight: bold;
            border-radius: 25px;
          }

        }
      }


    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Contacts/Contacts.vue